/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React from 'react'
import styles from '../../components/Components.module.css'
import 'semantic-ui-css/semantic.min.css';
import Footer from '../Common/Footer'
import ResponsiveContainer from "../Common/ResponsiveContainer";
import {Grid, Header, Image} from "semantic-ui-react";
import Rij from "../Common/Rij";

const Achtergrond = () => (
    <ResponsiveContainer>
        <div style={{display: 'relative', alignItems: 'flex-start', marginBottom: '1em'}}>
        <Grid container centered stackable>
            <Rij header={'Achtergrond'}>
                <Header as={'h1'} style={{fontSize: '3.6em'}}>Over mij</Header>
                        <p className={styles.rijP} style={{marginTop: '4em'}}>

                            <Image src={'/img/Auteursfoto-vierkant.png'} style={{width: '40%', maxWidth: '230px', height: 'auto', float: 'left', marginRight: '1rem', marginBottom: '0.5rem', filter: 'grayscale(90%)'}}/>
                            Op mijn achttiende las ik <span style={{fontStyle:'italic'}}>Open</span>, de autobiografie van André Agassi. Hij was een flamboyante
                            tennisser die furore maakte in de jaren 90, en acht grandslamtoernooien had gewonnen. In het
                            boek verkondigde Agassi dat hij tennis haat, en altijd al had gehaat. Fascinerend. Hoe kan
                            iemand zijn hele leven in het teken zetten van een sport waar hij een bloedhekel aan heeft?
                            Wie <span style={{fontStyle:'italic'}}>Open</span> leest, begrijpt het. Ik heb het boek twee keer achter elkaar gelezen, waarna ik
                            besloot dat ik ooit ook zoiets zou maken. <br/><br/>
                            Vijftien jaar later verscheen mijn autobiografie <span style={{fontStyle:'italic'}}>Zelfs vogels zijn verlegen</span>,
                            een maatschappijkritisch werk waarin de verlegen mens centraal staat.
                            Missie volbracht, zou de achttienjarige versie van mij kunnen denken. Maar ik ben nog lang niet uitgeschreven.
                            <br/><br/>
                            Wat drijft mensen, hoe worden ze wie ze zijn, en wat zou hun leven beter kunnen maken?
                            Het zijn vragen die mij altijd bezig hebben gehouden, en nu ook in mijn schrijfwerk terugkeren.
                            Bijvoorbeeld in grote interviews met inspirerende mensen. Of in de <span style={{fontStyle:'italic'}}>NRC</span>-rubrieken ‘Vrij’ en
                            ‘Ik doe iets goeds’ waarvoor ik Nederlanders portretteerde met bijzondere hobby’s en vrijwilligersbanen.
                            Of in mijn achtergrondstukken over alles wat met welzijn te maken heeft.
                            Er zijn nog zo veel verhalen om te vertellen, zo veel vertelvormen die ik nog niet heb uitgeprobeerd.
                            <br/><br/>
                            <span style={{fontWeight: 'bold'}}>Voor potentiële opdrachtgevers:</span> Ik ben afgestudeerd als filosoof, psycholoog en
                            neerlandicus, en volgde cursussen zoals roman schrijven en eindredactie. Ik schrijf columns,
                            reportages, persoonlijke interviews en essayistische verhalen, liefst met licht-ironische
                            ondertoon. Mijn stad is Rotterdam, waar ik met man en kind woon, en in mijn vrije tijd graag
                            rondjes langs de Rotte fiets. Ook heb ik een zwarte band in karate, maar dat is gelukkig een
                            hobby gebleven.

                        </p>
            </Rij>
            <Grid.Row>
                <Grid.Column width={10} style={{maxWidth: '80%'}}>
                </Grid.Column>
            </Grid.Row>
        </Grid>
        </div>
        <Footer/>
    </ResponsiveContainer>
)

export default Achtergrond
